import React from 'react';
import { useSelector } from 'react-redux';
import Behaviour from 'components/prism/behaviour';
import Subheader from 'components/prism/subheader';
import { Link } from 'react-router-dom';

export const Recommended = ({ text, data }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    return (
        <>
            <Subheader title={text.title} />
            <div className="mb10">{text.summary}</div>
            {text.browseAll?.trim() && (
                <div className="mb10">
                    <Link to="/library">{text.browseAll}</Link>
                </div>
            )}
            <div className={prismMultiColumn ? 'even-col' : ''}>
                {data.map(item => (
                    <Behaviour key={`recommended-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                ))}
            </div>
        </>
    );
};

export default Recommended;
